export default function startsWith() {
  return function link(array, search) {
    const matches = [];
    for (let i = 0; i < array.length; i++) {
      if (
        array[i].toLowerCase().indexOf(search.toLowerCase()) === 0 &&
        search.length < array[i].length
      ) {
        matches.push(array[i]);
      }
    }

    return matches;
  };
}
